import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'
import Image from './Image'

export default class Signature extends React.Component {
  static propTypes = {
    value: PropTypes.string,
    field: PropTypes.object
  }

  render() {
    let required = '(Opcional)'
    if (this.props.field && this.props.field.required) {
      required = '(Requerida)'
    }
    return (
      <div className={styles.container}>
        {this.props.value ? (
          <Image signatureId={this.props.value} />
        ) : (
          <div style={{maxWith: 100}} className={styles.pending}>
            <div>Firma pendiente </div>
            <div>{required}</div>
          </div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Sign/Document/Page/Field/Show/Signature/index.js